/**
 * The carats a lesson's draw takes at the pick, seen for a moment (lesson-redo
 * DESIGN.md E2.4: "a brief −10"). The balance itself lives in the avatar menu,
 * so the pick shows its own small "−10 ✦" by the card.
 *
 * card-selected answers only once the card is read (38-75s), so the flash
 * cannot wait for it. A 402 or a failed pick comes back at once, so the flash
 * waits a short grace first: a pick that fails in it shows nothing, and one
 * that fails later takes the flash down at once.
 */
export const PICK_CHARGE_GRACE_MS = 600
export const PICK_CHARGE_SHOW_MS = 1500

/** `pending` is communicateCardSelected's promise ({ failed } on a 402 or an error). */
export function pickChargeFlash(pending, { amount, reduced = false, onShow, onHide } = {}) {
  const n = Number(amount) || 0
  if (n <= 0 || reduced) return () => {}
  let failed = false
  let shown = false
  let showTimer = null
  let hideTimer = null
  const stop = () => {
    if (showTimer) { clearTimeout(showTimer); showTimer = null }
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null }
    if (shown) { shown = false; if (onHide) onHide() }
  }
  Promise.resolve(pending).then(
    (r) => { if (r && r.failed) { failed = true; stop() } },
    () => { failed = true; stop() },
  )
  showTimer = setTimeout(() => {
    showTimer = null
    if (failed) return
    shown = true
    if (onShow) onShow(n)
    hideTimer = setTimeout(() => { hideTimer = null; stop() }, PICK_CHARGE_SHOW_MS)
  }, PICK_CHARGE_GRACE_MS)
  return stop
}
